<template>
  <div>
    <div class="filterBg base-form-div">
      <el-form
        size="mini"
        :model="searchForm"
        label-position="right"
        label-width="120px"
        inline
      >
        <el-form-item label="发送方卡号:">
          <el-input
            v-model="searchForm.sendCardNumber"
            placeholder="请输入发送方卡号"
            class="filter-item"
            clearable
            @keyup.enter.native="handleFilter"
            @clear="handleFilter"
          />
        </el-form-item>
        <el-form-item label="时间:">
          <DatePicker
            :startTime.sync="searchForm.beginTime"
            :endTime.sync="searchForm.endTime"
          />
        </el-form-item>
      </el-form>
      <div>
        <el-button
          class="base-button"
          size="mini"
          icon="el-icon-video-play"
          @click="pathLine"
          type="success"
          >轨迹回放</el-button
        >
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >查询</el-button
        >
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          icon="el-icon-download"
          @click="exportFilter"
          >导出</el-button
        >
      </div>
    </div>
    <div class="listTable">
      <div class="margins">
        <span>
          <!-- <el-button size="mini" type="primary" icon="el-icon-plus" @click="addCard">新增</el-button> -->
          <!-- <el-button type="primary" @click="manageImport">导入</el-button>
                    <el-button type="primary" @click="downfileTransfer">导出</el-button> -->
        </span>
        <span>
          <!-- <el-button type="primary" @click="templateDown">模板下载</el-button> -->
        </span>
      </div>
      <YzTable
        :getDataAll="getData"
        max-height="340px"
        :columnApi="columns"
        :listApi="listArray"
        :searchForm="searchForm"
        :autoLoad="true"
        ref="YzTable"
      />
    </div>
  </div>
</template>

<script>
import { getCommonAjax } from "@/api/common";
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation";
// import dataLine from "./data.js"
var entityArr = [];
export default {
  data() {
    return {
      columns: "json/locations.json?v=2",
      listArray: "/location/pageLocation",
      searchForm: {
        page: 1,
        pageSize: 10,
        sendCardNumber: undefined,
        beginTime: undefined,
        endTime: undefined,
      },
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    viewer.clock.multiplier = 1;
    var entity = DBentityCollection.getById("轨迹信息");
    if (!entity) {
      return;
    }
    entity.show = false;
  },
  methods: {
    removeEntityArr() {
      entityArr.forEach((item) => {
        viewer.entities.remove(item);
      });

      entityArr = [];
    },
    pathLine() {
      var entity = DBentityCollection.getById("轨迹信息");
      if (!entity) {
        this.$message({
          showClose: true,
          message: "该卡号暂无轨迹数据，无法回放！",
          type: "warning",
          duration: 3 * 1000,
        });
        return;
      }

      var positions = entity.polyline.positions.getValue();

      if (!positions || positions.length < 1) {
        this.$message({
          showClose: true,
          message: "该卡号暂无轨迹数据，无法回放！",
          type: "warning",
          duration: 3 * 1000,
        });
        return;
      }

      if (positions.length == 1) {
        this.$parent.min();
        entity.show = true;
        viewer.flyTo(entity, {
          duration: 3,
          offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 15000), //（heading,pich,range）
        });
        return;
      }

      this.$parent.min();
      entity.show = true;
      var animation = new PathAnimation({
        entity: entity,
        positions: positions,
        speed: 1000,
        multiple: 1,
        //sumTime:10
      });

      animation.start();

      viewer.flyTo(entity, {
        duration: 3,
        //offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 15000),//（heading,pich,range）
      });

      // this.removeEntityArr();
      // for (let i = 0; i < positions.length; i++) {
      //     var position = positions[i];

      //     const entity_wx = new Cesium.Entity({
      //         position: position,
      //         point: {
      //             pixelSize: 10,
      //             color: Cesium.Color.TURQUOISE,
      //             outlineColor: Cesium.Color.YELLOW,
      //             outlineWidth: 2,
      //             heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      //             disableDepthTestDistance: Number.MAX_VALUE,
      //         },
      //         label: {
      //             text: "序号" + i + "\n" + position.id,
      //             font: '15px sans-serif',
      //             style: Cesium.LabelStyle.FILL,
      //             showBackground: true,
      //             backgroundColor: Cesium.Color.BLACK.withAlpha(0.6),
      //             pixelOffset: new Cesium.Cartesian2(0.0, 0.0),
      //             outlineWidth: 1,
      //             fillColor: Cesium.Color.DARKORANGE,
      //             horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
      //             disableDepthTestDistance: Number.MAX_VALUE,
      //             heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
      //         }

      //     });

      //     entityArr.push(entity_wx);
      //     viewer.entities.add(entity_wx);

      // }
    },
    getData(res) {
      var arr = res.result.slice(0,3000); // res.result.items;
      var positions = [];
      // arr.forEach(item => {
      //     var pos = Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude, item.altitude);
      //     positions.push(pos)
      // });
      var lineCoods = [];
      for (let i = 0; i < arr.length; i++) {
        var item = arr[i];
        var pos = Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude);
        //pos.id = item.id;
        positions.push(pos);

        lineCoods.push([item.longitude, item.latitude]);
      }

      positions = this.removeDuplicate(positions); //去重
    //   if (positions.length > 1) {
    //     var lineString = turf.lineString(lineCoods);
    //     var options = { tolerance: 0.0001, highQuality: true, mutate: true };
    //     var simplified = turf.simplify(lineString, options);
    //     var coordinates = simplified.geometry.coordinates;
    //     console.log(simplified);
    //     positions = this.coordinatesToPos(coordinates);
    //   }

      var entity = DBentityCollection.getById("轨迹信息");
      var text = `卡号(${this.searchForm.sendCardNumber})`;
      if (!entity) {
        entity = this.createFlydEntity(positions[0], "轨迹信息",text,positions);
        DBentityCollection.add(entity);
      }
      //entity.show = false;
      //entity.polyline.positions.setValue(positions);
      viewer.flyTo(entity, {
        duration: 3,
        //offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 15000),//（heading,pich,range）
      });
    },

    createFlydEntity(center, id, text, positions) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "设备",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "16px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -20), //6,229,72
          fillColor: new Cesium.Color(6 / 255, 229 / 255, 72 / 255),
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },
        model: {
          show: true,
          uri: "data/mx/feiji.glb", //模型的地址
          scale: modelScale, //模型缩放比例
          minimumPixelSize: modelMinimumPixelSize, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(
            Cesium.Color.fromRandom({
              alpha: 1.0,
            })
          ),
        },
      });
      return entity;
    },
    coordinatesToPos(coordinates) {
      var positions = [];
      for (let i = 0; i < coordinates.length; i++) {
        var coord = coordinates[i];
        var pos = Cesium.Cartesian3.fromDegrees(coord[0], coord[1]);
        positions.push(pos);
      }

      return positions;
    },
    removeDuplicate(positions) {
      if (positions.length < 2) {
        return positions;
      }
      let res = [];
      let j = 0;
      res.push(positions[0]);
      for (let i = 1; i < positions.length; i++) {
        if (
          res[j].x == positions[i].x &&
          res[j].y == positions[i].y &&
          res[j].z == positions[i].z
        ) {
          continue;
        }
        j++;
        res.push(positions[i]);
      }
      return res;
    },
    createBillboardEntity(center, positions) {
      const entity = new Cesium.Entity({
        id: "轨迹信息",
        position: center,
        billboard: {
          image: "data/img/marker/mark2.png",
          scale: 1.0,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        polyline: {
          positions: positions,
          width: 10,
          //granularity: 10, // 减少granularity可以减少顶点数量
          material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.YELLOW),
          // material: new Cesium.PolylineTrailLinkMaterialProperty(
          //     {
          //         color: new Cesium.Color(1.0, 1.0, 0.0, 1),
          //         duration: 3000,
          //         image: "data/img/effects/line-pulse.png"
          //     }
          // ),
          clampToGround: true,
        },
      });
      return entity;
    },
    exportFilter() {
      getCommonAjax("/location/exportLocation", this.searchForm, "arraybuffer")
        .then((res) => {
          this.downloadJsonFile(res, "轨迹信息记录_" + new Date().getTime() + ".xlsx");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    downloadJsonFile(data, fileName) {
      var blob = new Blob([data], { type: "application/octet-stream" });
      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.download = fileName;
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    },
    handleFilter() {
      this.searchForm.page = 1;
      this.$refs["YzTable"].getList(this.searchForm, true);
    },
    addCard() {
      this.$dialog.open({
        title: "添加设备",
        shade: true,
        area: {
          height: "350px",
          width: "400px",
        },
        location: {
          top: null,
          left: null,
          bottom: "300px",
          right: "20px",
        },
        content: {
          type: "vue",
          subCom: Add,
        },
      });
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletedUser({ id: row.id })
            .then(() => {
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch((e) => {
              //this.$message.error(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.filterBg {
  display: flex;
  justify-content: space-between;
}
</style>
